import React, { useState, PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import { i18n_go_to_sign_in } from '@yi/i18n/phrases/i18n_go_to_sign_in';
import { i18n_this_email_already_has_an_account } from '@yi/i18n/phrases/i18n_this_email_already_has_an_account';

import { commonButtonStyles } from '~/src/components/buttons/button-styles';
import { useLocale } from '~/src/components/LocaleProvider';
import { SignInModal } from '~/src/components/modals/SignInModal';
import { darkRed, fontWeight } from '~/styles';

const animationId = 'headShake';
const headShakeAnimation = `
  @keyframes ${animationId} {
    0% {
      transform: translateX(0);
    }

    6.5% {
      transform: translateX(-6px) rotateY(-9deg);
    }

    18.5% {
      transform: translateX(5px) rotateY(7deg);
    }

    31.5% {
      transform: translateX(-3px) rotateY(-5deg);
    }

    43.5% {
      transform: translateX(2px) rotateY(3deg);
    }

    50% {
      transform: translateX(0);
    }
  }

  animation: ${animationId} 1s ease-in-out;
`;

// Formik helperText is 'p', we cannot use 'div' instead of 'p', so as a workaround we use span with 'display:block'
const ErrorContaner = styled.span`
  ${headShakeAnimation}
  display: block;
  font-size: 16px;
  font-weight: ${fontWeight.semiBold};
  line-height: 20px;
  letter-spacing: 0.05em;
  text-align: center;
  background: ${darkRed};
  border-radius: 4px;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 16px;
  gap: 8px;
  margin-top: 4px;
`;

const Button = styled.button`
  ${commonButtonStyles};
  text-decoration: underline;
  cursor: pointer;
  height: auto;
  padding: 0;
  margin: 0;
  width: fit-content;
  &:hover {
    text-decoration: none;
  }
`;
export const ACCOUNT_EXISTS_ERROR = 'This email already has an account.';

export const AccountExistsError: React.FC<
  PropsWithChildren<{ errorMessage: string; email?: string }>
> = ({ errorMessage, email = '' }) => {
  const [showSignInModal, setShowSignInModal] = useState(false);
  const { locale } = useLocale();
  return (
    <>
      {errorMessage === ACCOUNT_EXISTS_ERROR ? (
        <ErrorContaner data-testid="account-exists-error-label" role="alert">
          {i18n_this_email_already_has_an_account(locale)}.
          <Button
            onClick={e => {
              e.preventDefault();
              setShowSignInModal(true);
            }}
            aria-label="go to sign in"
          >
            {i18n_go_to_sign_in(locale)}
          </Button>
        </ErrorContaner>
      ) : (
        <span style={{ color: darkRed, backgroundColor: '#fff', padding: '5px' }} role="alert">
          {errorMessage}
        </span>
      )}
      <SignInModal
        email={email}
        open={showSignInModal}
        setOpen={setShowSignInModal}
        hideCreateAccount
      />
    </>
  );
};
